export default __webpack_public_path__ + "static/media/Langley_NEXRAD.83496415.webp";